import { getCurrentSession } from '../../../lib/authentication';

export const savePreferences = ({ id, ...rest }) => {
    return getCurrentSession().then(result => {
        const { idToken } = result;
        return apigClient.usersIdPreferencesPost(
            { id },
            rest,
            {
                headers: {
                    Authorization: idToken
                }
            }
        );
    });
};

export const deletePreferences = ({ id }) => {
    return getCurrentSession().then(result => {
        const { idToken } = result;
        return apigClient.usersIdPreferencesDelete(
            { id },
            {},
            {
                headers: {
                    Authorization: idToken
                }
            }
        );
    });
};
